import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SalesNetwork } from '../../../models/sales-network.model';
import { KoncentroValidators } from './../../../modules/UIKit/validators/koncentro-validators';
import { SalesNetworkService } from './../../../services/sales-network/sales-network.service';
import { SourceSystemService } from './../../../services/source-system/source-system.service';

@Component({
  selector: 'app-sales-network-form',
  templateUrl: 'salesNetworkForm.component.html',
  styles: ['label.required:after {top: 0} .ui-grid-row {margin-bottom: 7px}']
})

export class SalesNetworkFormComponent implements OnInit {
  @Output() salesNetworkAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() salesNetworkUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxSalesNetwork: SalesNetwork;
  addEditForm: FormGroup;
  validation: any;
  invalidSubmit: boolean;
  sourceSystemList: Array<{ label: string, value: number }>
  show = {
    form: false
  }
  validators = {
    integerNotNegative: KoncentroValidators.integerNotNegative
  }

  constructor(
    private fb: FormBuilder,
    private srvSourceSystem: SourceSystemService,
    private srvSalesNetowrk: SalesNetworkService
  ) { }

  ngOnInit(): void {
    
    this.srvSalesNetowrk.getFields().subscribe(res => {
      this.validation = res;
    })

    this.sourceSystemList = [];
    this.sourceSystemList.push({ label: '', value: null });
    this.srvSourceSystem.getList().subscribe(res => {
      for (let i = 0; i < res.length; i++) {
        if (res[i].flg_state !== '1') {
          this.sourceSystemList.push({ label: res[i].name, value: res[i].id });
        }
      }
      this.addEditForm = this.fb.group({
        'code': new FormControl(this.dialogBoxSalesNetwork.code),
        'name': new FormControl(this.dialogBoxSalesNetwork.name),
        'description': new FormControl(this.dialogBoxSalesNetwork.description),
        'logo_name': new FormControl(this.dialogBoxSalesNetwork.logo_name),
        'logo': new FormControl(this.dialogBoxSalesNetwork.logo),
        'source_system_id': new FormControl(this.dialogBoxSalesNetwork.source_system_id),
        'company_host_code': new FormControl(this.dialogBoxSalesNetwork.company_host_code)
      });

      this.show.form = true;
    });
  }

  saveOrUpdate(): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }

    let newData = Object.assign({}, this.dialogBoxSalesNetwork, this.addEditForm.value);
    if (newData.id == null) {
      this.salesNetworkAdded.emit(newData);
    } else {
      this.salesNetworkUpdated.emit(newData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/sales-network/salesNetworkForm.component.ts